import { createSlice } from "@reduxjs/toolkit";
import CommonService from "@src/services/CommonService";
import { toast } from "react-toastify";
import { APIResponse,GraphDataRequest,GraphDataResponse } from '../types/Common';
import { STATUS_CODES } from "@src/config/constant";



const CommonSlice = createSlice({
    name: 'common',
    initialState: {
        common: {},
        documentList: [],
        mmvList: {},

    },
    reducers: {
        documentList: (state, action) => {
            state.documentList = action.payload
        },
        config: (state, action) => {
            state.common = action.payload;
        },
        mmvList: (state, action) => {
            state.mmvList = { ...state.mmvList, ...action.payload };
        }
    }
})

export default CommonSlice.reducer

const { documentList, config, mmvList } = CommonSlice.actions

export const getDocumentListing = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getDocumentListing(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        let data = response.data && response.data.data
                        resolve(data)
                        dispatch(documentList(data))
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getDashboardCount = (dashBoardCountRequest:any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {

        CommonService.getDashboardCount(dashBoardCountRequest).then(
            (response: APIResponse) => {

                if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const getPendingPayment = (pendingCountRequest: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {

        CommonService.getPendingPayment(pendingCountRequest).then(
            (response: APIResponse) => {

                if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const getDashboardGraphData = (params: GraphDataRequest): Promise<GraphDataResponse> => {
    return new Promise((resolve, reject) => {

        CommonService.getDashboardGraphData(params).then(
            (response: any) => {

                if (response && response.data && response.data.status === STATUS_CODES['success']) {
                    resolve(response.data);
                } else {
                    let errorMsg = response?.data?.message || '';
                    if (errorMsg) toast.error(errorMsg);
                    resolve(response?.data);  // Resolving with response data even if the status is not STATUS_CODES['success']
                }
            },
            (error: Error) => {
                toast.error("An error occurred while fetching the data");
                reject(error);  // Reject with error if the API call fails
            }
        );
    });
};


export const getMasterConfig = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getMasterConfig().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(config(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getMMVList = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        let mmvPatams = JSON.parse(JSON.stringify(params));
        delete mmvPatams['category_id'];

        CommonService.getMMVList(mmvPatams).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(mmvList({ [params['vehicle_usage']]: data }))

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const addDocument = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.addDocument(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                resolve(response.data)

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getNotificationCount = () => {
    return new Promise((resolve, reject) => {
        CommonService.getNotificationCount().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}


export const getNotificationList = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.getNotificationList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                resolve(response.data)
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const readNotificationHistory = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.readNotificationHistory(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                resolve(response.data)
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const addDocumentWeb = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.addDocumentWeb(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                resolve(response.data)

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}


export const getMasterConfigID = (headers?: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getMasterConfigID(headers).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(config(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}


export const getReporteeID = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getReporteeID(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        let data = response.data && response.data.data
                        resolve(data)
                        //dispatch(config(data))
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const getInsurerListID = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getInsurerListID(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        let data = response.data && response.data.data
                        resolve(data)
                        //dispatch(config(data))
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const getBrandListID = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getBrandListID(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        let data = response.data && response.data.data
                        resolve(data)
                        //dispatch(config(data))
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getFormFieldID = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getFormFieldID(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        let data = response.data && response.data.data
                        resolve(data)
                        //dispatch(config(data))
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const getDocUploadUrl = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.getDocUploadUrl(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}